import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { asyncScheduler, filter, fromEvent, throttleTime } from 'rxjs';

@Component({
  selector: 'app-org-event-page-slides',
  templateUrl: './org-event-page-slides.component.html',
  styleUrls: ['./org-event-page-slides.component.scss']
})
export class OrgEventPageSlidesComponent {
  @ViewChild('swiper') 
  set swiperRef(swiperRef: ElementRef) {
    this._swiperRef = swiperRef;};
  get swiperRef(): ElementRef {
    return this._swiperRef;
  }
  
  @Input() block = null;
  public sliderConfig = {};

  private _swiperRef = null;

  public swiperEl = null;

  constructor() {
    fromEvent(window, 'resize').pipe(
      filter(() => this.swiperEl !== null),
      throttleTime(250, asyncScheduler, {
        leading: true,
        trailing: true
      }),
      takeUntilDestroyed()
    ).subscribe(() => {
      this.swiperEl.updateSize();
    });
  }

  ngOnInit() {
    this.sliderConfig = {
      pagination: { 
        el: '.swiper-pagination.sponsors', 
        clickable: true 
      },
      autoHeight: true,
      slidesPerView: 3.5,
      preloadImages: true,
      allowTouchMove: true,
      grabCursor: true,
    };
  }

  ngAfterViewInit() {
   this.swiperEl = new window['Swiper'](this.swiperRef.nativeElement, this.sliderConfig);
  }
}
